__turbopack_context__.v({
  "axis": "RgAH6G_axis",
  "axisTitle": "RgAH6G_axisTitle",
  "barOurs": "RgAH6G_barOurs",
  "barTheirs": "RgAH6G_barTheirs",
  "bracket": "RgAH6G_bracket",
  "chart": "RgAH6G_chart",
  "cursor": "RgAH6G_cursor",
  "cursorDot": "RgAH6G_cursorDot",
  "data": "RgAH6G_data",
  "dataBody": "RgAH6G_dataBody",
  "dot": "RgAH6G_dot",
  "dotMuted": "RgAH6G_dotMuted",
  "draw": "RgAH6G_draw",
  "fade": "RgAH6G_fade",
  "fill": "RgAH6G_fill",
  "fine": "RgAH6G_fine",
  "grid": "RgAH6G_grid",
  "groupLabel": "RgAH6G_groupLabel",
  "groupMeta": "RgAH6G_groupMeta",
  "grow": "RgAH6G_grow",
  "halo": "RgAH6G_halo",
  "header": "RgAH6G_header",
  "leader": "RgAH6G_leader",
  "legend": "RgAH6G_legend",
  "lineAlt": "RgAH6G_lineAlt",
  "lineOurs": "RgAH6G_lineOurs",
  "note": "RgAH6G_note",
  "noteAccent": "RgAH6G_noteAccent",
  "plot": "RgAH6G_plot",
  "row": "RgAH6G_row",
  "rowHead": "RgAH6G_rowHead",
  "rowLabel": "RgAH6G_rowLabel",
  "rowSources": "RgAH6G_rowSources",
  "rowValue": "RgAH6G_rowValue",
  "rows": "RgAH6G_rows",
  "subtitle": "RgAH6G_subtitle",
  "svg": "RgAH6G_svg",
  "swatch": "RgAH6G_swatch",
  "tick": "RgAH6G_tick",
  "title": "RgAH6G_title",
  "track": "RgAH6G_track",
});
